/** @param {number} n */
export function round2(n) {
  return Math.round(n * 100) / 100
}

/** Stripe ACH Direct Debit: 0.8% per transaction, capped at $5. */
export const STRIPE_ACH_RATE = 0.008
export const STRIPE_ACH_FEE_CAP = 5

/** Stripe card: 2.9% + $0.30 per transaction. */
export const STRIPE_CARD_RATE = 0.029
export const STRIPE_CARD_FLAT_FEE = 0.3

/** Stripe-style ACH fee on subtotal after platform fees. */
export function stripeAchFee(subtotal) {
  return Math.min(round2(subtotal * STRIPE_ACH_RATE), STRIPE_ACH_FEE_CAP)
}

/** Stripe card fee on subtotal after platform fees. */
export function stripeCardFee(subtotal) {
  return round2(subtotal * STRIPE_CARD_RATE + STRIPE_CARD_FLAT_FEE)
}
